<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-0">
          <a-row
            class='py-2'
          >
            <a-col
              :sm='24'
              :lg='15'
              class='pr-1'
            >
              <a-input
                style="width: 100%"
                placeholder="Buscar..."
                @keyup.enter="getConsignmentSettings(10, 0, searchText)"
                v-model:value="searchText"
              />
            </a-col>
            <a-col
              :sm='12'
              :lg='4'
              class='pl-1'
            >
              <button
                style="width: 100%"
                class="btn bg-holcim-bright-green text-white"
                @click="getConsignmentSettings(10, 0, searchText)"
              >
                <i class="fe fe-refresh-cw" />
                Buscar
              </button>
            </a-col>
            <a-col
              :sm='12'
              :lg='4'
              class='pl-1'
            >
              <button
                class="btn bg-holcim-dark-blue text-white"
                style="width: 100%"
                @click='openModal'
              >
                <i class="fe fe-plus" />
                Nuevo
              </button>
            </a-col>
            <a-col
              :sm='12'
              :lg='1'
              class='pl-1'
            >
              <router-link
                to="/catalogos/principal"
                style="width: 100%"
                class="btn bg-holcim-bright-blue"
              >
                <i class="fe fe-arrow-left" />
              </router-link>
            </a-col>
          </a-row>
        </div>

        <a-modal
          :closable="false"
          :visible="visible"
          title="Registro de Leyenda"
        >
          <a-form
            :model="form"
            ref="ruleForm"
            :rules="rules"
            @finish="submit"
            layout="vertical"
            label-align="left"
          >
            <a-form-item required label="No. Orden:" name="order">
              <a-input v-model:value.trim="form.order" placeholder="No. Orden" />
            </a-form-item>

            <a-form-item required label="Leyenda:" name="name">
              <a-textarea v-model:value="form.name" placeholder="Nombre de Leyenda" :rows="5" />
            </a-form-item>

            <a-form-item required label="Tipo de Leyenda:" name="type">
              <a-select
                v-model:value="form.type"
                default-value="Recomendación"
              >
                <a-select-option value="Recomendación">Recomendación</a-select-option>
                <a-select-option value="Notas">Nota</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Estatus:" name="activeRecord">
              <a-checkbox v-model:value="form.activeRecord">
                Estatus
              </a-checkbox>
            </a-form-item>

            <error-manager-component
              v-if="errorHandler.errorDescription.errors.length > 0"
              :errors="errorHandler.errorDescription.errors"
            />

            <a-row
              class='py-1'
            >
              <a-col
                span="8" offset="10"
                v-if="formLoad"
              >
                <a-spin tip="Cargando..."/>
              </a-col>
              <a-col
                span="12" class="pt-1 pl-1" offset="6" v-else>
                <button
                  type="submit"
                  style="width: 100%"
                  class="btn bg-holcim-bright-green text-white"
                >
                  <i class="fe fe-save" />
                  Guardar
                </button>
              </a-col>
            </a-row>
          </a-form>

          <template #footer>
            <a-button
              key="back"
              @click="closeModal"
            >
              <i class='fe fe-x-circle pr-2'/>
              Cerrar
            </a-button>
          </template>
        </a-modal>

        <div class="card-body">
          <consignment-settings-table
            :data="consignmentSettings"
            :loading="tableLoading"
            @openModal="eventOpenModal"
            @softDelete="eventSoftDelete"
          />
          <a-pagination
            class="pt-4"
            v-model="paginatorCurrentPage"
            :total="paginatorTotalItems"
            @change="onChangePaginator"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ConsignmentSettingsTable from './components/ConsignmentSettingsTable'
import useConsignmentSetting from '../../../composables/useConsignmentSetting'
import ErrorManagerComponent from '../../../components/errorManagerComponent'

export default {
  name: 'ConsigmentSettingsIndex',
  components: { ErrorManagerComponent, ConsignmentSettingsTable },
  setup() {
    const {
      searchText,
      visible,
      formId,
      form,
      formLoad,
      rules,
      consignmentSettings,
      tableLoading,
      errorHandler,
      ruleForm,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      openModal,
      closeModal,
      getConsignmentSettings,
      submit,
      deleteRecord,

      eventOpenModal,
      eventSoftDelete,
    } = useConsignmentSetting()

    return {
      searchText,
      visible,
      formId,
      form,
      formLoad,
      rules,
      consignmentSettings,
      tableLoading,
      errorHandler,
      ruleForm,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      openModal,
      closeModal,
      getConsignmentSettings,
      submit,
      deleteRecord,

      eventOpenModal,
      eventSoftDelete,
    }
  },
}
</script>

<style scoped>

</style>
